import Font24 from '@assets/icons/font-24.svg'
import { Icon } from './Icon'

export const Font24Icon = Icon(Font24)
